
import React from 'react';

export default function TeamShortTermGoalsInformationPage2() 
{
    return ( 
        <> 
            <div class="row">
                <div class="col-1 mt-1">
                    <a href="#"><img class="card-icon" src="./images/stg.svg" alt="goal" border="0"/></a>                     
                </div>
                <div class="col">
                    Display currently selected Short-Term Goal and Assigned Team Actions.
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-1">
                    <a href="#"><img class="card-icon" src="./images/add.svg" alt="add" border="0"/></a>
                </div>
                <div class="col">
                    Add a new Short-Term Goal (requires Team Admin privileges)
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-1 mt-2">
                    <a href="#"><img class="card-icon" src="./images/select.svg" alt="comments" border="0"/></a>
                </div>
                <div class="col mt-2">
                   Select an existing Short-Term Goal.
                </div>
            </div>
        </> 
    );
}
